<template>
	<div>
		<el-row style="margin-top: 20px;margin-bottom: 20px;">
			<el-col align="right">
				<el-tooltip
						class="item"
						effect="dark"
						content="PDF"
						placement="top"
						v-if="requestForm && requestForm.hash_id">
					<el-button round @click="generatePDF()" type="primary">
						{{ label }}
					</el-button>
				</el-tooltip>

				<ShowDocuments :closeShowDocument="closeShowDocument"
				               :activeShowDocument="activeShowDocument"
				               :fileNameHash="fileNameHash"
				               :urlPdfGenerate="urlPdfGenerate"
				               v-if="activeShowDocument"/>
				<br/>
			</el-col>
		</el-row>

	</div>
</template>

<script>
	import {mapState, mapGetters, mapActions, mapMutations} from "vuex";
	import ShowDocuments from '@/utils/ShowDocuments';

	export default {
		components: {
			ShowDocuments
		},
		props: {
			type: {
				required : true
			},
			label: {
				required : true
			},
		},

		data() {
			return {
				fileData:{},
				fileNameHash: null,
				activeShowDocument : false
			}
		},
		computed: {
			...mapGetters("form", {
				requestForm: "requestForm",
				onlyRead: "onlyRead"
			}),
			...mapState([
				'route'
			]),
			status(){
				return (this.requestForm.last_log && this.requestForm.last_log.cat_acquisition_status_id)
					? this.requestForm.last_log.cat_acquisition_status_id : null;
			},
			profile() {
				return this.$store.state.user.profile;
			},
		},
		methods:{

			generatePDF(){

				if(this.status == 1 && this.profile == 2){
					this.autoSave();
				}else{
					this.autoSave();
					let url = `/api/acquisitions/pdf/${this.requestForm.hash_id}/${this.type}`;
					this.urlPdfGenerate = url;
					this.activeShowDocument =true;
				}

			},
			closeShowDocument(){
				this.activeShowDocument = false;
			},
			autoSave(){
				this.showLoading();

				let method = null;
				let url = null;

				if (this.route.params.id) {
					method = 'PUT';
					url =  '/api/acquisitions/service/'+this.route.params.id;
				}else{
					method = 'POST';
					url =   '/api/acquisitions/service';
				}


				let _requestForm = this.requestForm;


				const options = {
					method: method,
					data: {
						data: _requestForm,
						status_alias : 1,
						downloadPdf: true
					},
					url : url
				};
				axios(options).then(response => {
					this.hideLoading();
					if (response.data.success) {

						let url = `/api/acquisitions/pdf/${this.requestForm.hash_id}/${this.type}`;
						this.urlPdfGenerate = url;
						this.activeShowDocument =true;
					}
					else {
						this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});

					}
				}).catch(error => {
					this.hideLoading();
					this.$store.dispatch('notifications/error', {msg: 'No se pudo completar la acción.'}, {root: true});
				});
			},
			showLoading() {
				this.$store.dispatch(
					"loading/spinner",
					{msg: "Cargando Datos...", status: true},
					{root: true}
				);
			},
			hideLoading() {
				this.$store.dispatch("loading/spinner", {}, {root: true});
			},

		}
	}
</script>

<style scoped>

</style>